export default "__VITE_ASSET__BR_877kJ__"